import { createFileRoute } from "@tanstack/react-router"
import { lazyImportRouteComponent } from '../../../../utils/lazyImportRouteComponent'

export const Route = createFileRoute(
  "/app/admin-settings/automatic-background-jobs/"
)({
  component: lazyImportRouteComponent(
      () => import("./-components/JobDefinitionsPage"),
      "JobDefinitionsPage"
    ),
  beforeLoad(ctx) {
    return {
      getTitle: () => ctx.context.t && ctx.context.t("AutomaticBackgroundJobs"),
    }
  },
})
